import styled from 'styled-components';

import { colors, fontFamily, functions, zIndex } from '../../ui/variables';

export const LoadingProgressBarStyle = styled.div`
  @keyframes rotate {
    0% {
      transform: rotate(0);
    }

    50% {
      transform: rotate(-180deg);
    }

    100% {
      transform: rotate(-360deg);
    }
  }

  ${zIndex.space};
  align-items: center;
  background-color: ${functions.rgba(colors.white, 0.8)};
  display: flex;
  flex-wrap: wrap;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;

  .loading-message-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .loading-image-wrapper {
      margin: 0 auto 10px;
      width: 130px;

      svg {
        animation: rotate 800ms infinite linear;
        display: block;
        fill: ${colors.softBlue};
        height: auto;
        width: 100%;
      }
    }

    .loading-message-wrapper {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.softBlue};
      font-size: 14px;
      line-height: 18px;
      margin: 32px auto 10px;
      max-width: 220px;
      padding: 16px;
      text-align: center;
      width: 100%;
    }

    .loading-progress-bar {
      width: 100%;
      background-color: #e0e0e0;
      border-radius: 5px;
      overflow: hidden;
      margin-top: 10px;
      position: relative;
    }

    .loading-progress {
      height: 20px;
      background-color: ${colors.softBlue};
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      transition: width 0.3s ease;
    }

    .loading-progress-text {
      color: #fff;
      font-weight: bold;
      position: absolute;
      right: 10px;
    }
  }
`;
